import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import * as offerActions from '../../redux/offers';

const OfferTab = styled.div`
  width: 125px;
  height: 25px;
  border-radius: 8px 8px 0px 0px;
  font-family: BrandonGrotesque-Medium;
  font-size: 15px;
  letter-spacing: 1.4px;
  line-height: 30px;
  text-align: center;
  margin-right: 3px;
  display: inline-block;
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#415859' : '#eeeeee')};
  color: ${({ active }) => (active ? '#e8e2ce' : '#909798')};
`;

function OffersMenu(props: { type: string; changePage: Function }) {
  return (
    <>
      {['active', 'upcoming', 'past'].map((type) => (
        <OfferTab key={type} active={props.type === type} onClick={() => props.changePage(type)}>
          {type.capitalize()}
        </OfferTab>
      ))}
    </>
  );
}

export default connect(null, offerActions)(OffersMenu);
